import 'animate.css';

import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useNavigate } from 'react-router-dom';

import * as routes from '../../../constants/Routing';
import useResendUserValidationEmail from '../../../hooks/user/useResendUserValidationEmail';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { intercom } from '../../../services/intercom';
import { AuthBody, AuthBodyFooter } from '../Auth.styled';

interface LoginEmailNotValidatedProps {
  email: string;
  setNotValidatedEmail: (email?: string) => void;
}

export const LoginEmailNotValidated = ({ email, setNotValidatedEmail }: LoginEmailNotValidatedProps) => {
  const navigate = useNavigate();

  const {
    // error: resendError,
    // success: resendSuccess,
    isLoading: resendIsLoading,
    run: resendValidationMail,
  } = useResendUserValidationEmail({ email: email ?? `` });

  return (
    <>
      <AuthBody container direction="column" justifyContent="center">
        <Grid container direction="column" className="animate__animated animate__fadeIn">
          <Grid container justifyContent="center">
            <Text intlId="auth.login.not_validated" variant="h5" />
          </Grid>

          <VSpacer large />

          <Grid item container alignItems="center" direction="row" justifyContent="center">
            <Text
              variant="label"
              tagName="span"
              style={{ fontSize: `13px` }}
              intlId="auth.login.not_validated.info"
              intlValues={{
                b: (chunks: any) => (
                  <Text isBold style={{ fontSize: `13px` }} tagName="span" onClick={() => navigate(routes.AUTH.LOGIN)}>
                    {chunks}
                  </Text>
                ),
                email,
              }}
            />
          </Grid>

          <VSpacer medium />

          <Grid item container alignItems="center" direction="row" justifyContent="center">
            <Button
              id="register_resend"
              buttonType="button"
              intlId="auth.login.not_validated.resend"
              size="large"
              onClick={() => {
                resendValidationMail();
              }}
              disabled={resendIsLoading}
              style={{
                width: `100%`,
              }}
            />
          </Grid>

          <VSpacer small />

          <Grid item container alignItems="center" direction="row" justifyContent="center">
            <Text
              variant="button"
              style={{ fontSize: `12px` }}
              intlId="auth.login.not_validated.problems_with_validation"
              onClick={() => {
                intercom.open();
              }}
            />
          </Grid>
        </Grid>
      </AuthBody>

      <Grid item>
        <VSpacer medium />
      </Grid>

      <AuthBodyFooter item container justifyContent="space-between">
        <Grid item>
          <Text
            isBold
            style={{
              fontSize: `12px`,
            }}
            variant="button"
            intlId="auth.login"
            onClick={() => setNotValidatedEmail()}
          />
        </Grid>

        <Grid item>
          <Text
            isBold
            style={{
              fontSize: `12px`,
            }}
            variant="button"
            intlId="auth.login.register"
            onClick={() => navigate(routes.AUTH.REGISTER)}
          />
        </Grid>
      </AuthBodyFooter>
    </>
  );
};
